import Relay from '../feature/Relay/Relay'

export default function RelayDetailedView () {
  return <Relay />
}
